module.exports = new __parcel__URL__("pin_service.f27d8391.png").toString();